import { EEthereumNetworkId } from '@ankr.com/provider';
import BigNumber from 'bignumber.js';

import { AutomateApi } from 'modules/api';
import { ZERO } from 'modules/common';

import { api } from '../api';
import { cacheTags } from '../cacheTags';

export const { useGetNativeTokenUSDPriceQuery } = api.injectEndpoints({
  endpoints: build => ({
    getNativeTokenUSDPrice: build.query<
      BigNumber,
      {
        chainId: EEthereumNetworkId | null;
      }
    >({
      queryFn: async ({ chainId }) => {
        if (!chainId) {
          return { data: ZERO };
        }

        const api = new AutomateApi(chainId);

        return { data: await api.getNativeTokenUSDPrice() };
      },
      providesTags: [cacheTags.account, cacheTags.balance],
    }),
  }),
});
